import PropTypes from 'prop-types'
import { idPropType } from '../common/id-prop-type'

/**
 * @typedef {Object} ElectricVehicleBatteryInsight
 *
 * @property {number} [batteryHealth]               - The electric vehicle battery health [in %]
 * @property {number} [energyThroughput]            - The electric vehicle battery energy throughput [in kWh]
 * @property {number} [fullChargingCycles]          - The number of electric vehicle full charge
 * @property {string} objectId                      - The object id unique identifier
 * @property {number} [timeSpentBelowLowerLimit]    - Time of electric vehicle battery spent below lower limit [in %]
 * @property {number} [timeSpentOverUpperLimit]     - Time of electric vehicle battery spent over upper limit [in %]
 * @property {number} [usageOfFastCharging]         - The ratio between usage of fast and slow charging systems [in %]
 */
export const electricVehicleBatteryInsightPropType = PropTypes.shape({
    batteryHealth: PropTypes.number,
    energyThroughput: PropTypes.number,
    fullChargingCycles: PropTypes.number,
    objectId: idPropType.isRequired,
    timeSpentBelowLowerLimit: PropTypes.number,
    timeSpentOverUpperLimit: PropTypes.number,
    usageOfFastCharging: PropTypes.number
})
